export const generateId = (idLength, possibilities) => {
    let possible;
    switch (possibilities) {
        case '1':
            possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            break;
        case '2':
            possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
            break;
        case '3':
            possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
            break;
        case '4':
            possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
            break;
        case '5':
            possible = '1234567890';
            break;
        default:
            possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            break;
    }
    let id = '';

        for (let i = 0; i < idLength; i++) {
            id += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return id;
}